enum PaymentMethodType {
    BankAccount = 'BankAccount',
    Card = 'Card',
}

export default PaymentMethodType;
